import React from 'react';
import { createPortal } from 'react-dom';

interface ModalProps {
  isOpen: boolean;
  onClose: () => void;
  title?: string;
  showCloseButton?: boolean;
  children: React.ReactNode;
  className?: string;
  contentClassName?: string;
}

const Modal: React.FC<ModalProps> = ({
  isOpen,
  onClose,
  title,
  showCloseButton = true,
  children,
  className = '',
  contentClassName = ''
}) => {
  if (!isOpen) return null;

  const modalContent = (
    <div
      className={`fixed inset-0 bg-black/50 flex items-center justify-center p-4 z-[9999] ${className}`}
      onClick={onClose}
    >
      <div
        className={`bg-white rounded-3xl max-w-md w-full p-6 max-h-[80vh] overflow-y-auto ${contentClassName}`}
        onClick={(e) => e.stopPropagation()}
      >
        {(title || showCloseButton) && (
          <div className="flex justify-between items-center mb-6">
            {title && (
              <h2 className="text-2xl font-bold text-gray-800">{title}</h2>
            )}
            {showCloseButton && (
              <button
                onClick={onClose}
                className="text-gray-500 hover:text-gray-700 text-2xl font-bold ml-auto"
              >
                ×
              </button>
            )}
          </div>
        )}

        {children}
      </div>
    </div>
  );

  return createPortal(modalContent, document.body);
};

export default Modal;